import { animated, useSpring } from '@react-spring/web';
import { FC } from 'react';
import classes from './NumberLoader.module.scss';
interface NumberLoaderProps {
  digitCount: number;
}
export const NumberLoader: FC<NumberLoaderProps> = ({
  digitCount
}) => {
  const numbersToRotate = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const springConfig = (duration: number): {
    from: {
      top: string;
    };
    to: {
      top: string;
    };
    loop: boolean;
    config: {
      duration: number;
    };
  } => ({
    from: {
      top: '-190px'
    },
    to: {
      top: '19px'
    },
    loop: true,
    config: {
      duration
    }
  });
  const stylesHundreds = useSpring<{
    top: number;
  }>(springConfig(3500));
  const stylesTens = useSpring<{
    top: number;
  }>(springConfig(2900));
  const styles = useSpring<{
    top: number;
  }>(springConfig(2400));
  const getStyle = (index: number) => {
    const stylesDictionary = {
      0: stylesHundreds,
      1: stylesTens,
      2: styles
    };
    return stylesDictionary[index];
  };
  return <div className={classes.loaderBlock} data-sentry-component="NumberLoader" data-sentry-source-file="NumberLoader.tsx">
            {new Array(digitCount).fill(1).map((_, index) => <div className={classes.animatedWrapper} key={index}>
                    <animated.div style={getStyle(index)} className={classes.animatedNumbers}>
                        {numbersToRotate.map((item, index) => <div key={`${item}` + `${index}`}>{item}</div>)}
                    </animated.div>
                </div>)}
        </div>;
};